 $(document).ready(function(){
   
   
   //homepage
    $('.showWrap').mousemove(function(e){
    var amountMovedX = (e.pageX * -1 / 70);
    var amountMovedY = (e.pageY * -1 / 70);
    var t = $('#landing-content')
  TweenMax.to(t, 0.3, {css:{x:amountMovedX, y:amountMovedY}});
  });
  
   
   //scrollto
   $('a[href*="#"]').click(function(e) {
     e.preventDefault()
   $('html,body').animate({scrollTop:$(this.hash).offset().top-150}, 500)  
    })
   
   //waypoints
    //home
  $('.fDown').waypoint(function() {
$(this).addClass('ON');
}, { offset: '50%' });
   
   
     //waypoints
  
  //home
  $('.homeSections section').waypoint(function() {
$(this).addClass('ON');
}, { offset: '50%' });

   //munutab
   var dnv = $('.dropNav')
   var dHgt = dnv.outerHeight()
   dnv.css('top',-dHgt)
  
    var smu = $('.menutab')
    smu.click(function(event){
    event.preventDefault()
    var a = $('.top')
    var b = $('.bottom')
    var c = $('.middle')
    var d = $('.fixed')
    var t = $(this)
    
    if (t.hasClass('ON')){
    t.removeClass('ON')
    TweenMax.to(a, .2, {rotation:0}); 
    TweenMax.to(b, .2, {rotation:0});
    TweenMax.to(c, .2, {opacity:1 , marginTop:4 , marginBottom:4});
    TweenMax.to(t, .2, {marginTop:16});
    TweenMax.allTo([dnv,d], .2, {top:"-="+dHgt+"px"});
    
    }else{
    t.addClass('ON')
    TweenMax.to(t, .2, {marginTop:22});
    TweenMax.to(a, .2, {rotation:45}); 
    TweenMax.to(b, .2, {rotation:-45}); 
    TweenMax.to(c, .2, {opacity:0 , marginTop:-3 , marginBottom:-3});
    TweenMax.allTo([dnv,d], .2, {top:"+="+dHgt+"px"});
     
    }
  
    });
    
 
   
   //scrollbar
 $("html").niceScroll({cursorborder:"none",cursorcolor:"#78473F",autohidemode:false,background:"#e3998e",cursorwidth:9,zindex:9999,});

    
   //Backstretch

$('.bs').each(function(){
var t = $(this)
var d = t.attr('data-img')
if (t.hasClass('sw')){
var a =$(window).width()/t.attr('data-aspect')
t.height(a)
t.backstretch(d)
}else{
t.backstretch(d)
}
});
    
    
    ///PRDOUCT
    
    
    //set height of main image
    var wHeight = $(window).height()
    $('.fixed_image_panel').height(wHeight)

       
    //product slider
    
   $('.fixed_image_panel').cycle({
  
    timeout:0,
    prev:".leftTab",
    next:".rightTab",
     fx:'scrollHorz',
    slides:"> .cycleSlide",
    });
    
    //pInfo
   $('.pInfo ul').cycle({
  
    timeout:0,
    prev:".leftTab",
    next:".rightTab",
    
    slides:"> .islide",
    });
    
   
    //fix nav on scroll
     $(window).scroll(function(){
    
       if (smu.hasClass('ON')){
     var wHeight = $(window).height()-167
         }else{
      var wHeight = $(window).height()     
         }
     var a = $('div.sideMenu')
    if ($(window).scrollTop() >= wHeight+18) {
    $('.prdPrchs').addClass('fxd');
    TweenMax.to(a, .1, {left:0 });
    $('.prdPrchs p').fadeOut(400);
    }
    else {
    $('.prdPrchs').removeClass('fxd');
    TweenMax.to(a, .1, {left:-50});
    $('.prdPrchs p').fadeIn(100);
    }
});
    
    

    
    
    
    
    
  });